import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { aiApi } from '../api';
import Brains from './Brains';
import Competition from './Competition';

// Aba unificada de bots (Fase 1 da reorganizacao de UX — ver vault Claude/Specs).
// O seletor define qual viso renderiza; a viso escondida nem monta, entao
// para de fazer polling (o ganho de performance vem de graca, por construcao).
// Query keys permanecem os mesmos ('brains', 'arena', 'sentiment'...) —
// o cache e compartilhado com o resto do app.

const MODES = [
  { id: 'brains', label: '🧠 Cérebros' },
  { id: 'arena', label: '🏆 Arena (legado)' },
];

const SENTIMENT_LABEL = {
  risk_on: { label: 'Risco ligado', color: '#34d399' },
  risk_off: { label: 'Risco desligado', color: '#f87171' },
  neutral: { label: 'Neutro', color: '#94a3b8' },
};

export default function Bots() {
  const [params, setParams] = useSearchParams();
  const mode = params.get('mode') === 'arena' ? 'arena' : 'brains';
  const setMode = (id) => setParams(id === 'arena' ? { mode: 'arena' } : {});

  // Badge de sentimento no cabecalho (compartilha a query key com a viso Cerebros)
  const { data: sentiment } = useQuery({
    queryKey: ['sentiment'],
    queryFn: () => aiApi.get('/sentiment').then(r => r.data),
    refetchInterval: 60_000,
    enabled: mode === 'brains',
  });
  const sent = SENTIMENT_LABEL[sentiment?.bias] || SENTIMENT_LABEL.neutral;

  return (
    <div>
      {/* Barra de modo */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16,
        flexWrap: 'wrap',
      }}>
        <div style={{
          display: 'inline-flex', background: '#1e293b', border: '1px solid #334155',
          borderRadius: 10, padding: 3, gap: 2,
        }}>
          {MODES.map(m => {
            const on = mode === m.id;
            return (
              <button key={m.id} onClick={() => setMode(m.id)} style={{
                background: on ? '#0f2a3f' : 'transparent',
                color: on ? '#38bdf8' : '#64748b',
                border: 'none', borderRadius: 8, padding: '7px 16px',
                cursor: 'pointer', fontSize: 13, fontWeight: 700,
              }}>{m.label}</button>
            );
          })}
        </div>
        {mode === 'brains' && sentiment?.bias && (
          <span style={{ fontSize: 12, color: '#64748b' }}>
            Sentimento: <b style={{ color: sent.color }}>{sent.label}</b>
            {sentiment?.fear_greed_index != null && ` · F&G ${sentiment.fear_greed_index}`}
          </span>
        )}
        {mode === 'arena' && (
          <span style={{ fontSize: 12, color: '#475569' }}>
            Modo legado — mantido por comparacao; o desenvolvimento novo acontece nos Cérebros.
          </span>
        )}
      </div>

      {mode === 'arena' ? <Competition /> : <Brains />}
    </div>
  );
}
